import { ICrudGenericFields } from 'models/CrudInterface'

export const productAttributesGlobalUploadFieldsDropDown: Array<ICrudGenericFields> =
	[
		{
			id: 'descrip', // Id del campo en SQL
			type: 'text', // Tipo de campo
			labelWidth: 'col-sm-3', //
			width: 'col-sm-9', // Ancho del campo
			height: 'col-sm-12', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 30, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'categoria',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'productCategory',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'Orden',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'orderProductAttr',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'codigo',
			type: 'text',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'product_select', // Id del campo en SQL
			type: 'text', // Tipo de campo
			labelWidth: 'col-sm-3', //
			width: 'col-sm-10', // Ancho del campo
			height: 'col-sm-12', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 10, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: true, // Booleano para desabilitar
			comboData: 'couriers', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		}
	]
